import { ConfigServiceProvider } from '../../../core/services/config-service/config-service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserTask } from '../../interfaces/user-task.interface';
import { Observable } from 'rxjs';

@Injectable()
export class UserTaskService {
  constructor(private configService: ConfigServiceProvider, private http: HttpClient) {}

  public get(id: string): Observable<UserTask> {
    return this.http.get<UserTask>(this.configService.getEngineUrl('userTask').replace('{id}', id.toString()));
  }

  public complete(id: string, variables: any): Observable<any> {
    return this.http.post(this.configService.getEngineUrl('completeUserTask').replace('{id}', id.toString()), { variables });
  }

  public claim(id: string): Observable<any> {
    return this.http.post<UserTask>(this.configService.getEngineUrl('claimUserTask').replace('{id}', id.toString()), {});
  }
}



// WEBPACK FOOTER //
// ./src/modules/user-tasks/services/user-task.service/user-task.service.ts